// The partner portal's entry point (partners.html), a separate bundle from Mothership's
// main.tsx: it imports nothing from Mothership's pages (partnerBundle.test.ts checks).
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { PartnersPage } from './PartnersPage';
// Library first, then its opt-in document defaults and Olytic's own theme.
import '@olytic/foundation/styles.css';
import '@olytic/foundation/base.css';
import '@olytic/foundation/themes/olytic.css';

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('The partner portal root element is missing.');
}

createRoot(rootElement).render(
  <StrictMode>
    <PartnersPage />
  </StrictMode>,
);
